var _rect, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCopy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 56,
    height: 56,
    rx: 4,
    fill: "#F6F6F6"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2279_7344)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.8594 39.1406L25.862 30.138C26.0436 29.9564 26.29 29.8544 26.5469 29.8544C26.8038 29.8544 27.0501 29.9564 27.2318 30.138L30.2213 33.1276C30.403 33.3092 30.6494 33.4112 30.9062 33.4112C31.1631 33.4112 31.4095 33.3092 31.5912 33.1276L39.1406 25.5781V39.1406H16.8594Z",
    fill: "#C5EFDF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.8594 39.1406L25.862 30.138C26.0436 29.9564 26.29 29.8544 26.5469 29.8544C26.8038 29.8544 27.0501 29.9564 27.2318 30.138L30.2213 33.1276C30.403 33.3092 30.6494 33.4112 30.9062 33.4112C31.1631 33.4112 31.4095 33.3092 31.5912 33.1276L39.1406 25.5781",
    stroke: "#191919",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.3594 25.5781H39.1406V32.3594",
    stroke: "#191919",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.6719 27.0312L17.7177 21.863C17.1681 21.3133 16.8594 20.5678 16.8595 19.7905C16.8596 19.0132 17.1685 18.2677 17.7182 17.7182C18.2679 17.1686 19.0134 16.8599 19.7907 16.86C20.568 16.8601 21.3134 17.1689 21.863 17.7186L22.6719 18.5275L23.4808 17.7186C23.8092 17.3902 24.2109 17.1446 24.6529 17.0019C25.0949 16.8592 25.5645 16.8235 26.0229 16.8979C26.4814 16.9722 26.9156 17.1545 27.2898 17.4295C27.6641 17.7046 27.9676 18.0647 28.1753 18.4801C28.4504 19.0303 28.5454 19.653 28.4468 20.2602C28.3482 20.8673 28.0611 21.4281 27.6261 21.863L22.6719 27.0312Z",
    fill: "#FF5A4F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.1753 18.4801C27.9676 18.0647 27.6641 17.7046 27.2898 17.4295C26.9156 17.1544 26.4814 16.9722 26.0229 16.8979C25.5645 16.8235 25.0949 16.8591 24.6529 17.0018C24.211 17.1445 23.8092 17.3902 23.4808 17.7186L22.6719 18.5275L21.863 17.7186C21.4102 17.26 20.8185 16.9639 20.1801 16.8763C19.5416 16.7887 18.8921 16.9144 18.3325 17.2341C17.7729 17.5537 17.3345 18.0493 17.0857 18.6437C16.8368 19.2382 16.7913 19.8982 16.9563 20.5212C17.6787 21.2578 18.5408 21.8428 19.4921 22.242C20.4434 22.6412 21.4648 22.8466 22.4965 22.8462C23.635 22.8474 24.7597 22.5981 25.791 22.1159C26.8223 21.6337 27.7349 20.9305 28.464 20.0562C28.5166 19.5142 28.4166 18.9683 28.1753 18.4801Z",
    fill: "#FFC8C3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.6719 27.0312L17.7177 21.863C17.1681 21.3133 16.8594 20.5678 16.8595 19.7905C16.8596 19.0132 17.1685 18.2677 17.7182 17.7182C18.2679 17.1686 19.0134 16.8599 19.7907 16.86C20.568 16.8601 21.3134 17.1689 21.863 17.7186L22.6719 18.5275L23.4808 17.7186C23.8092 17.3902 24.2109 17.1446 24.6529 17.0019C25.0949 16.8592 25.5645 16.8235 26.0229 16.8979C26.4814 16.9722 26.9156 17.1545 27.2898 17.4295C27.6641 17.7046 27.9676 18.0647 28.1753 18.4801C28.4504 19.0303 28.5454 19.653 28.4468 20.2602C28.3482 20.8673 28.0611 21.4281 27.6261 21.863L22.6719 27.0312Z",
    stroke: "#191919",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2279_7344"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(16 16)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopy);
export default __webpack_public_path__ + "static/media/copy.48d949f0a3ae3198cf4df737dd220f81.svg";
export { ForwardRef as ReactComponent };